"use client";

import React, { useState } from "react";
import { Star, CircleCheck, ChevronRight, ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const reviews = [{
  id: 1,
  name: "Helenita Pelegrini",
  date: "7 meses atrás",
  rating: 5,
  text: "Foi experiência incrível e mágica, lugar lindo com pessoas especiais!, viajar com a KG turismo foi maravilhoso...",
  avatarColor: "bg-stone-400",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_1.png"
}, {
  id: 2,
  name: "Rocio Estacio",
  date: "7 meses atrás",
  rating: 5,
  text: "Maravilloso. Excelente serviço. Grupo de viaje alegre, positivo y seguro. Viajé a Lencois Maranhenses. Lindo hotel...",
  avatarColor: "bg-orange-700",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_2.png"
}, {
  id: 3,
  name: "Kildaire Lima Brand...",
  date: "7 meses atrás",
  rating: 5,
  text: "Tivemos uma experiência muito positiva, na viagem recente ao Peru, especialmente em Lima, Cusco e Machu...",
  avatarColor: "bg-orange-600",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_3.png"
}, {
  id: 4,
  name: "Maria Oliveira",
  date: "2 meses atrás",
  rating: 5,
  text: "Viagem impecável para a Europa. Tudo muito bem organizado e seguro para nós mulheres. Recomendo muito!",
  avatarColor: "bg-blue-500",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_4.png"
}, {
  id: 5,
  name: "Ana Paula Santos",
  date: "1 mês atrás",
  rating: 5,
  text: "A KG Viagens superou todas as expectativas no Pantanal. O suporte 24h faz toda a diferença na segurança.",
  avatarColor: "bg-green-600",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_5.png"
}, {
  id: 6,
  name: "Carla Mendes",
  date: "3 meses atrás",
  rating: 4,
  text: "Ótima experiência em Gramado. O roteiro foi muito bem pensado para o nosso grupo de amigas.",
  avatarColor: "bg-purple-500",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_6.png"
}, {
  id: 7,
  name: "Beatriz Farias",
  date: "5 meses atrás",
  rating: 5,
  text: "Minha primeira viagem solo com a KG e me senti totalmente acolhida. O grupo era maravilhoso.",
  avatarColor: "bg-pink-500",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_7.png"
}, {
  id: 8,
  name: "Sonia Regina",
  date: "8 meses atrás",
  rating: 5,
  text: "Fernando de Noronha foi um sonho realizado. Organização nota 10 da equipe KG Viagens.",
  avatarColor: "bg-teal-600",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_8.png"
}, {
  id: 9,
  name: "Luciana Costa",
  date: "10 meses atrás",
  rating: 5,
  text: "O cruzeiro pelo Rio Nilo foi mágico. Guia em português e hotéis de altíssimo padrão.",
  avatarColor: "bg-indigo-500",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_9.png"
}, {
  id: 10,
  name: "Marta Silveira",
  date: "4 meses atrás",
  rating: 5,
  text: "Atenção aos detalhes é o forte deles. Viajei para a Itália e não precisei me preocupar com nada.",
  avatarColor: "bg-red-500",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_10.png"
}, {
  id: 11,
  name: "Regina Duarte",
  date: "6 meses atrás",
  rating: 4,
  text: "Bonito é realmente lindo, e a KG escolheu os melhores passeios para o nosso perfil.",
  avatarColor: "bg-yellow-600",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_11.png"
}, {
  id: 12,
  name: "Teresa Cristina",
  date: "9 meses atrás",
  rating: 5,
  text: "Marrocos com a KG foi uma imersão cultural fantástica. Segurança total em todos os momentos.",
  avatarColor: "bg-emerald-500",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_12.png"
}, {
  id: 13,
  name: "Fernanda Lima",
  date: "11 meses atrás",
  rating: 5,
  text: "A viagem para a Grécia foi perfeita. O planejamento personalizado atendeu todos os meus desejos.",
  avatarColor: "bg-cyan-600",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_13.png"
}, {
  id: 14,
  name: "Isabel Rocha",
  date: "2 meses atrás",
  rating: 5,
  text: "Excelente atendimento desde o primeiro contato. A viagem para a Argentina foi muito tranquila.",
  avatarColor: "bg-violet-500",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_14.png"
}, {
  id: 15,
  name: "Glória Maria",
  date: "1 mês atrás",
  rating: 5,
  text: "Viajar com mulheres da mesma faixa etária é maravilhoso. Fiz amizades que levarei para a vida.",
  avatarColor: "bg-rose-500",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_15.png"
}, {
  id: 16,
  name: "Patrícia Amorim",
  date: "3 meses atrás",
  rating: 5,
  text: "O Jalapão é rústico mas a KG garantiu o máximo de conforto possível. Experiência nota mil.",
  avatarColor: "bg-amber-600",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_16.png"
}, {
  id: 17,
  name: "Sandra Helena",
  date: "5 meses atrás",
  rating: 4,
  text: "Portugal foi encantador. Os hotéis boutique selecionados eram simplesmente maravilhosos.",
  avatarColor: "bg-lime-600",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_17.png"
}, {
  id: 18,
  name: "Vera Lúcia",
  date: "7 meses atrás",
  rating: 5,
  text: "A KG Viagens entende o que nós mulheres buscamos: segurança, conforto e boas risadas.",
  avatarColor: "bg-fuchsia-500",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_18.png"
}, {
  id: 19,
  name: "Cláudia Raia",
  date: "8 meses atrás",
  rating: 5,
  text: "Dubai e Abu Dhabi foram experiências de luxo inesquecíveis. Organização impecável.",
  avatarColor: "bg-sky-500",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_19.png"
}, {
  id: 20,
  name: "Eliane Giardini",
  date: "10 meses atrás",
  rating: 5,
  text: "O roteiro pelo Sul da França foi muito elegante. Gastronomia e vinhos excelentes.",
  avatarColor: "bg-slate-500",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_20.png"
}, {
  id: 21,
  name: "Zezé Polessa",
  date: "4 meses atrás",
  rating: 5,
  text: "Chapada dos Veadeiros com guia privativo foi a melhor escolha. KG Viagens é top!",
  avatarColor: "bg-zinc-600",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_21.png"
}, {
  id: 22,
  name: "Lília Cabral",
  date: "6 meses atrás",
  rating: 5,
  text: "Viagem para o Japão muito bem estruturada. O suporte local foi fundamental.",
  avatarColor: "bg-neutral-500",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_22.png"
}, {
  id: 23,
  name: "Cássia Kis",
  date: "9 meses atrás",
  rating: 4,
  text: "A Patagônia Chilena é deslumbrante. A logística de transporte foi muito eficiente.",
  avatarColor: "bg-stone-500",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_23.png"
}, {
  id: 24,
  name: "Marieta Severo",
  date: "11 meses atrás",
  rating: 5,
  text: "Cruzeiro pelo Alasca foi uma aventura confortável e segura. Recomendo a KG para todas.",
  avatarColor: "bg-orange-500",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_24.png"
}, {
  id: 25,
  name: "Irene Ravache",
  date: "2 meses atrás",
  rating: 5,
  text: "O atendimento da KG é muito humano e personalizado. Me senti cuidada o tempo todo.",
  avatarColor: "bg-red-600",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_25.png"
}, {
  id: 26,
  name: "Nívea Maria",
  date: "1 mês atrás",
  rating: 5,
  text: "Viagem para o Egito com grupo de mulheres foi a melhor decisão do ano. Inesquecível.",
  avatarColor: "bg-blue-600",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_26.png"
}, {
  id: 27,
  name: "Aracy Balabanian",
  date: "3 meses atrás",
  rating: 5,
  text: "A KG Viagens proporciona experiências que vão além do turismo, são vivências reais.",
  avatarColor: "bg-green-500",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/review_destination_27.png"
}];
export default function PremiumGoogleReviews() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [currentSlide, setCurrentSlide] = useState(0);
  const [expandedId, setExpandedId] = useState<number | null>(null);
  const whatsappUrl = "https://wa.me/5548988221618";
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 3) % reviews.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 3 + reviews.length) % reviews.length);
  };
  return <section id="premiumgooglereviews" className="bg-background py-12 md:py-16 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="mb-12">
          <div className="border-t border-border/50 pt-12 flex flex-col lg:flex-row gap-12">
            <div className="lg:w-1/4 flex flex-col items-center text-center lg:items-start lg:text-left">
              <h2 className="text-2xl font-serif font-bold mb-4 !text-[rgba(27,164,172,1)] md:text-3xl">Histórias de Quem Viajou</h2>
              <p className="text-sm mb-6 leading-relaxed text-foreground">
                Relatos reais de pessoas que descobriram novos horizontes com a segurança, o requinte e o acolhimento que só a KG VIAGENS proporciona.
              </p>
              <div className="flex gap-0.5 mb-2">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-[#F6BB06] text-[#F6BB06]" aria-hidden="true" />)}
              </div>
              <p className="text-sm text-muted-foreground mb-4">
                Com base em <span className="font-bold text-foreground">39 avaliações no Google</span>
              </p>
              <div className="flex items-center justify-center lg:justify-start">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/google_logo.png" alt="Google" width="292" height="100" style={{
                height: "32px",
                width: "auto",
                objectFit: "contain",
                flexShrink: 0
              }} loading="lazy" />
              </div>
            </div>

            <div className="lg:w-3/4 relative">
              <div className="overflow-hidden">
                <div className="flex transition-transform duration-500 ease-in-out" style={{
                transform: `translateX(-${currentSlide * (100 / 3)}%)`
              }}>
                  {reviews.map((review, i) => <div key={review.id} data-index={i} className="w-full md:w-1/3 shrink-0 px-2">
                      <div className="bg-muted/30 rounded-lg p-5 shadow-sm flex flex-col h-full relative">
                        <div className="flex items-start justify-between mb-3">
                          <div className="flex gap-3">
                            <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-bold ${review.avatarColor}`}>
                              {review.name.charAt(0)}
                            </div>
                            <div>
                              <h3 className="text-sm font-bold text-foreground leading-tight">
                                {review.name}
                              </h3>
                              <p className="text-[11px] text-muted-foreground">
                                {review.date}
                              </p>
                            </div>
                          </div>
                          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/google_icon_small.png" alt="Google" className="w-4 h-4" loading="lazy" />
                        </div>

                        <div className="flex items-center gap-0.5 mb-2">
                          {[...Array(5)].map((_, starIdx) => <Star key={starIdx} className="w-3.5 h-3.5 fill-[#F6BB06] text-[#F6BB06]" />)}
                          <CircleCheck className="w-3.5 h-3.5 text-blue-500 ml-1" />
                        </div>

                        <div className="flex gap-3 flex-1">
                          <div className="flex-1">
                            <p className={`text-xs text-foreground leading-relaxed ${expandedId === review.id ? "" : "line-clamp-4"}`}>
                              {review.text}
                            </p>
                            <Button variant="link" className="p-0 h-auto text-[11px] text-muted-foreground hover:no-underline mt-2" onClick={() => setExpandedId(expandedId === review.id ? null : review.id)}>
                              {expandedId === review.id ? "Leia menos" : "Leia mais"}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>

              <div className="flex justify-between absolute top-1/2 -translate-y-1/2 left-0 right-0 pointer-events-none px-2">
                <Button variant="outline" size="icon" onClick={prevSlide} aria-label="Avaliações anteriores" className="pointer-events-auto bg-background rounded-full shadow-md border-none size-8 hover:bg-accent transition-colors">
                  <ChevronLeft className="size-4" />
                </Button>
                <Button variant="outline" size="icon" onClick={nextSlide} aria-label="Próximas avaliações" className="pointer-events-auto bg-background rounded-full shadow-md border-none size-8 hover:bg-accent transition-colors">
                  <ChevronRight className="size-4" />
                </Button>
              </div>

              <div className="flex justify-center gap-2 mt-6">
                {[...Array(Math.ceil(reviews.length / 3))].map((_, i) => <Button key={i} data-index={i} variant="ghost" onClick={() => setCurrentSlide(i * 3)} className={`p-0 min-h-0 min-w-0 h-2 rounded-full transition-all duration-300 hover:bg-transparent ${Math.floor(currentSlide / 3) === i ? "bg-primary w-4" : "bg-muted-foreground/30 w-2"}`} aria-label={`Ver avaliações ${i * 3 + 1} a ${Math.min(i * 3 + 3, reviews.length)}`} />)}
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center justify-center gap-4 mt-16">
          <Link to={whatsappUrl} newTab className="no-underline" aria-label="Falar com a KG Viagens pelo WhatsApp">
            
          </Link>
        </div>
      </div>
    </section>;
}